export default __webpack_public_path__ + "static/media/section-4.bf53e3b3.png";